import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "slide-item bg-white rounded-borders q-pa-md" }
const _hoisted_2 = { class: "button-wrap row no-wrap justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slide_item_button = _resolveComponent("slide-item-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      style: { 'background-image': `url('${_ctx.slide.image}')` },
      class: "image",
      ref: "sliderImage"
    }, null, 4),
    _createVNode("p", {
      textContent: _toDisplayString(_ctx.slide.description),
      class: "q-mt-sm text-body2 q-mb-none"
    }, null, 8, ["textContent"]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_slide_item_button, {
        button: _ctx.slide.button,
        onClickButtonWithPayload: _cache[1] || (_cache[1] = 
					payload => _ctx.$emit('click-button-with-payload', payload)
				)
      }, null, 8, ["button"])
    ])
  ]))
}